import { appStore, IEvent, MessageBus } from '@tom-ui/utils'
import { JourneyResponse } from '@yard/app/api'
import { EventTypes } from '@yard/messages/eventsTypes'
import { DeleteResponse } from '@yard/messages/models/delete-response.model'
import { journeyService } from '@yard/services/journey.service'
import { computed, makeObservable } from 'mobx'
import { BaseEntityStore } from './base/BaseEntityStore'

export class JourneyStore extends BaseEntityStore<JourneyResponse> {
  private isFetched = false
  private readonly disposers: Array<() => void> = []

  constructor(private readonly messageBus: MessageBus) {
    super()
    makeObservable(this, {
      journeys: computed,
    })

    this.disposers.push(
      this.messageBus.subscribeEvent<JourneyResponse>(
        EventTypes.JourneyUpsertedEvent,
        this.handleUpsertedEvent,
      ),
      this.messageBus.subscribeEvent<DeleteResponse>(
        EventTypes.JourneyDeletedEvent,
        this.handleDeletedEvent,
      ),
    )
  }

  dispose(): void {
    this.disposers.forEach(d => d())
    this.disposers.length = 0
  }

  async loadOpenJourneys() {
    if (this.isFetched) return
    try {
      const journeys = await journeyService.getOpenJourneys()
      this.updateStoreItems(journeys)
      this.isFetched = true
    } catch (e) {
      appStore.setShowAlert('error', (e as any)?.response?.data?.detail ?? 'An error occurred')
    }
  }

  get journeys(): Record<number, JourneyResponse> {
    return this.items.reduce(
      (acc, journey) => {
        acc[journey.id] = journey
        return acc
      },
      {} as Record<number, JourneyResponse>,
    )
  }

  private handleUpsertedEvent = (event: IEvent<JourneyResponse>) => {
    const response = event.payload
    if (!response) return

    this.updateStoreItem(response, response.id)
  }

  private handleDeletedEvent = (event: IEvent<DeleteResponse>) => {
    const response = event.payload
    if (!response) return
    this.deleteStoreItem(response.id)
  }
}
